/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.querySelector('.thb-quick-search');
    this.redesignSearch = document.querySelector('.thb-quick-search--form-container-redesign');
    this.button = document.getElementById('quick-search');
    this.close_button = this.container.querySelector('.thb-search-close');
    this.input = this.redesignSearch.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.container.querySelector('.thb-quick-search--results');
    this.predictiveSearchResultsWrapper = this.container.querySelector('.thb-quick-search--results-container');
    this.emptyState = this.predictiveSearchResultsWrapper.querySelector('.thb-quick-search--results--empty-container');
    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.redesignSearch.querySelector('form.searchform');
    if (!form) return;
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.searchFocusables = this.redesignSearch.querySelectorAll('input, button');

    this.button.addEventListener('click', (event) => {
      var _this = this;
      event.preventDefault();
      document.querySelector('.header-section').classList.toggle('search-open');

      if (document.querySelector('.header-section').classList.contains('search-open')) {
        _this.setSearchFocusable(true);
        setTimeout(function () {
          _this.input.focus({
            preventScroll: true
          });
        }, 100);
        dispatchCustomEvent('search:open');
      } else {
        _this.setSearchFocusable(false);
      }

      return false;
    });

    document.addEventListener('click', (event) => {
      if (document.querySelector('.header-section').classList.contains('search-open')) {
        if (!this.input.contains(event.target) && 
            !this.predictiveSearchResultsWrapper.contains(event.target) && 
            event.target !== this.button) {
          this.close();
        }
      }
    });

    // Close.
    if (this.close_button) {
      this.close_button.addEventListener('click', (event) => {
        this.close();
        event.preventDefault();
      });
    }
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  categoryToggle() {
    this.category_toggle = this.container.querySelectorAll('.search-categories a');

    this.category_toggle.forEach((link) => {
      link.addEventListener('click', (event) => {
        [].forEach.call(this.category_toggle, function (el) {
          el.classList.remove('active');
        });
        link.classList.add('active');
        let target = link.getAttribute('href');
        this.container.querySelectorAll('.search-results').forEach((section) => {
          section.classList.remove('active');
        });
        this.container.querySelector(target).classList.add('active');

        event.preventDefault();
      });
    });

  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.emptyState.classList.remove('hidden');
      this.predictiveSearchResults.classList.add('hidden');
      return;
    } else {
      this.emptyState.classList.add('hidden');
      this.predictiveSearchResults.classList.remove('hidden');
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {

          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.predictiveSearchResults.classList.add('active');

    this.categoryToggle();
  }

  setSearchFocusable(focusable) {
    this.searchFocusables.forEach(el => {
      el.setAttribute('tabindex', focusable ? '0' : '-1');
    });
  }

  open() {
    document.querySelector('.header-section').classList.add('search-open');
    this.setSearchFocusable(true);
  }

  close() {
    document.querySelector('.header-section').classList.remove('search-open');
    this.setSearchFocusable(false);
    this.redesignSearch.style.display = 'none';
    setTimeout(() => {
      this.redesignSearch.style.display = 'block';
    }, 300);
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});